<template>
  <el-dialog class="product-add-dialog" :visible.sync="data.visible" :title="title"
             width="620px"
             center>
    <div class="pv-content">
      <el-form label-width="220px">
        <el-form-item label="标题">
          <el-col :span="16" style="width: 80%">
            <el-input v-model="data.row.title" placeholder="请输入内容"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="副标题">
          <el-col :span="16" style="width: 80%">
            <el-input v-model="data.row.subtitle" placeholder="请输入内容"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="描述">
          <el-col :span="16" style="width: 80%">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="data.row.introduction">
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="创建时间" class="divider">
          {{ data.row.created_print }}
        </el-form-item>
        <el-form-item label="商品类型">
          {{ data.row.mdse_type }}
        </el-form-item>
        <el-form-item label="标价(元)">
          <el-input-number v-model="data.row.marked_price" :step="0.01" :min="0" name="total_price"
                           placeholder="不在前端显示" style="width: 60%"></el-input-number>
        </el-form-item>
        <el-form-item label="售价(元)" class="divider">
          <el-input-number v-model="data.row.selling_price" :step="0.01" :min="0" name="total_price"
                           placeholder="不在前端显示" style="width: 60%"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-col :span="16" style="width: 80%">
            <el-select v-model="data.row.state"
                       clearable
                       placeholder="修改状态">
              <el-option
                v-for="item in global.productMdseStateListMini"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="备注(仅后台可见)">
          <el-col :span="16" style="width: 80%">
            <el-input type="textarea" v-model="data.row.note" name="note" placeholder="不在前端显示"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="data.loading" @click="handleOK">修改</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      rules: {
        title: [
          {required: true, message: '请输入套餐标题', trigger: 'blur'}
        ],
        subtitle: [
          {required: true, message: '请输入副标题', trigger: 'blur'}
        ]
      }
    }
  },
  props: {
    title: '',
    data: {
      loading: false,
      visible: false,
      row: {}
    }
  },
  methods: {
    handleOK (e) {
      let that = this
      that.$emit('ok', e)
      // that.$refs.ruleForm.validate((valid) => {
      //   if (!valid) {
      //     console.log('error submit!!')
      //     return false
      //   }
      //   that.$emit('ok', e)
      // })
    }
  }
}
</script>

<style>
.product-add-dialog .el-dialog {
  background: #e5e9f2;
}

.product-add-dialog .el-dialog__header {
  padding: 0 20px 0px 20px;
  height: 50px;
  background-color: #fff;
}

.product-add-dialog .el-dialog__title {
  color: #0C0C0C;
  line-height: 50px;
}

.product-add-dialog .el-dialog__body {
  padding: 0 0 20px 0;
}

.product-add-dialog .pv-content {
  padding-top: 5px;
  width: 620px;
  min-height: 400px;
  margin-left: auto;
  margin-right: auto;
}

.product-add-dialog .pv-content .el-form-item {
  margin-bottom: 10px;
}

.product-add-dialog .pv-content .el-form-item.divider {
  border-bottom: 1px solid #348fe2;
}

.product-add-dialog .pv-content .el-form-item__label {
  color: #0C0C0C;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductAddDialog.vue